import { render, staticRenderFns } from "./LoadingPanel.vue?vue&type=template&id=4158c86a&scoped=true"
import script from "./LoadingPanel.vue?vue&type=script&lang=ts"
export * from "./LoadingPanel.vue?vue&type=script&lang=ts"
import style0 from "./LoadingPanel.vue?vue&type=style&index=0&id=4158c86a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4158c86a",
  null
  
)

export default component.exports